import React from "react";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ width, height, data }) => {
  try {
    if (!data || !Array.isArray(data.data)) {
      throw new Error("Invalid data format");
    }

    const labels = data.data.map(item => item.label);
    const values = data.data.map(item => item.value);

    const chartData = {
      labels,
      datasets: [
        {
          label: "Value",
          data: values,
          borderWidth: 1,
          // Optionally add backgroundColor handling here
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { position: "top" },
        tooltip: { enabled: true },
      },
    };

    return (
      <div style={{ width, height }}>
        <Pie data={chartData} options={options} />
      </div>
    );
  } catch (error) {
    console.error("PieChart render error:", error);
    return (
      <div style={{ color: "red", padding: "10px" }}>
        Use Another favorite prompt to generate
      </div>
    );
  }
};

export default PieChart;
